<template>
	<div>
		
		<stato-fase
			:fase-with-stati="faseWithStati"
			:pratica="pratica"
			:pratica-diff="praticaDiff"
			@update-id-stato="pratica.id_stato_fase_7 = $event"
			:disabled="isLoading"
			:action="action"
		></stato-fase>
		
		<!--<div-->
		<!--	:style="`height: 1px; background-color: ${$vuetify.theme.currentTheme.primary}`"-->
		<!--	class="my-4"-->
		<!--&gt;</div>-->
		
		<!--<v-row class="mb-5 font-weight-medium">-->
		<!--	<v-col>-->
		<!--		<div v-html="faseWithStati.descrizione"></div>-->
		<!--	</v-col>-->
		<!--</v-row>-->
		
		<v-row>
			<v-col>
				<template v-if="(action == 'store' && isAccountManager)
					|| (action == 'edit' && ((isCoordinatore && pratica.id_stato_fase_7 != 15) || isAccountManager))"
				>
					<v-badge
						:value="haveFilesBeenModified.screenshot_invio"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-file-input
							v-model="files.screenshot_invio"
							label="Screenshot schermata del click"
							hide-details
							outlined
							dense
							clearable
							accept="image/png, image/jpeg, image/jpg"
							truncate-length="120"
							@change="setChanged(files.screenshot_invio)"
							@click:clear="pratica.path_screenshot_invio = null"
							:loading="isLoadingScreenshotInvio"
							:disabled="isLoading"
						>
							<template
								v-slot:append
								v-if="pratica.path_screenshot_invio !== null && !isLoadingScreenshotInvio"
							>
								<template>
									<v-progress-circular
										v-if="downloadingScreenshotInvio"
										size="24"
										width="3"
										color="primary"
										indeterminate
									></v-progress-circular>
									<v-icon
										v-else
										class="ml-3"
										@click="download(pratica.path_screenshot_invio, 'screenshot_invio')"
									>
										mdi-tray-arrow-down
									</v-icon>
								</template>
							</template>
						</v-file-input>
					</v-badge>
				</template>
				
				<template v-else-if="action == 'show'
					|| (isCoordinatore && pratica.id_stato_fase_7 == 15)"
				>
					<v-text-field
						:value="getFileNameFromPath(pratica.path_screenshot_invio)"
						label="Screenshot schermata del click"
						hide-details
						outlined
						dense
						readonly
					>
						<template
							v-slot:append
							v-if="pratica.path_screenshot_invio !== null"
						>
							<template>
								<v-progress-circular
									v-if="downloadingScreenshotInvio"
									size="24"
									width="3"
									color="primary"
									indeterminate
								></v-progress-circular>
								<v-icon
									v-else
									class="ml-3"
									@click="download(pratica.path_screenshot_invio, 'screenshot_invio')"
								>
									mdi-tray-arrow-down
								</v-icon>
							</template>
						</template>
					</v-text-field>
				</template>
			</v-col>
		</v-row>
		
		<template v-if="!isCliente || (isCliente && pratica.id_stato_fase_7 != 14)">
			<v-row v-if="pratica.data_ora_screenshot_invio">
				<v-col cols="6" class="d-flex justify-space-between align-center">
					<div>
						Caricato il {{ getDateFromDateTime(pratica.data_ora_screenshot_invio) }}
					</div>
					<v-btn
						v-if="isCliente"
						color="secondary"
						@click="download(pratica.path_screenshot_invio, 'screenshot_invio')"
						:disabled="isLoadingBase64ScreenshotInvio"
						:loading="downloadingScreenshotInvio"
					>
						Scarica
					</v-btn>
				</v-col>
			</v-row>
			
			<v-row>
				<v-col cols="6">
					<v-progress-linear
						v-if="isLoadingBase64ScreenshotInvio"
						indeterminate
					></v-progress-linear>
					<v-img
						v-else
						:src="base64ScreenshotRegistrazione"
						contain
					></v-img>
				</v-col>
				<v-col cols="6">
					<v-badge
						v-if="!isCliente"
						:value="praticaDiff.includes('descrizione_screenshot_invio')"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<!-- v-if="pratica.descrizione_screenshot_invio || isAccountManager" -->
						<v-textarea
							label="Descrizione Screenshot Schermata del Click"
							outlined
							:value="pratica.descrizione_screenshot_invio"
							@input="pratica.descrizione_screenshot_invio = $event !== '' ? $event : null"
							:readonly="!isAccountManager"
							:disabled="isLoading"
							persistent-placeholder
							auto-grow
						></v-textarea>
					</v-badge>
					
					<p
						v-else-if="isCliente && pratica.descrizione_screenshot_invio"
						v-html="pratica.descrizione_screenshot_invio"
					></p>
				</v-col>
			</v-row>
		</template>
		
		<!--<v-row v-if="pratica.descrizione_screenshot_invio || isAccountManager">-->
		<!--	<v-col>-->
		<!--		<v-textarea-->
		<!--			outlined-->
		<!--			v-model="pratica.descrizione_screenshot_invio"-->
		<!--			:readonly="!isAccountManager"-->
		<!--			:disabled="isLoading"-->
		<!--		></v-textarea>-->
		<!--	</v-col>-->
		<!--</v-row>-->
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { eventBus } from "@/event-bus";
export default {
	props: ['value', 'action', 'faseWithStati', 'praticaDiff', 'haveFilesBeenModified'],
	data() {
		return {
			pratica: {
				id: null,
				id_stato_fase_7: null,
				ci_sono_aggiornamenti_fase_7: false,
				path_screenshot_invio: null,
				descrizione_screenshot_invio: null,
				data_ora_screenshot_invio: null
			},
			isLoadingScreenshotInvio: false,
			files: {
				screenshot_invio: null
			},
			downloadingScreenshotInvio: false,
			isLoadingBase64ScreenshotInvio: false,
			base64ScreenshotRegistrazione: null
		}
	},
	
	created() {
		this.isSettingPratica = true;
		// this.pratica = Object.assign({}, this.value);
		this.pratica = this.value;
		this.isSettingPratica = false;
		
		if (this.pratica.ci_sono_aggiornamenti_fase_7 && this.isCliente) {
			this.pratica.ci_sono_aggiornamenti_fase_7 = false;
			this.$emit('input', this.pratica);
			this.$emit('aggiornamenti-visualizzati', {
				praticaId: this.pratica.id,
				aggiornamentoKey: 'ci_sono_aggiornamenti_fase_7',
				aggiornamentoValue: false
			});
			this.salvaAggiornamentiVisualizzati(this.pratica.id, 'ci_sono_aggiornamenti_fase_7');
		}
		
		if (this.pratica.path_screenshot_invio !== null) {
			this.getBase64ScreenshotInvio();
			
			if (this.action != 'show' && !this.isCliente) this.getScreenshotInvio();
		}
	},
	
	computed: {
		...mapGetters({
			isAccountManager: 'auth/isAccountManager',
			isCliente: 'auth/isCliente',
			isCoordinatore: 'auth/isCoordinatore'
		}),
		isLoading() {
			return this.isSettingPratica
				|| this.isLoadingScreenshotInvio;
		}
	},
	
	watch: {
		pratica: {
			handler(newPratica) {
				if (!this.isLoading) {
					this.$emit('input', newPratica)
				}
			},
			deep: true
		},
		files: {
			handler(newFiles) {
				if (!this.isLoading) {
					this.$emit('update-files', newFiles)
				}
			},
			deep: true
		},
		isLoading(newVal) {
			this.$emit('is-loading', newVal)
		},
	},
	
	methods: {
		async getScreenshotInvio() {
			this.isLoadingScreenshotInvio = true;
			this.files.screenshot_invio = await this.getFile(this.pratica.path_screenshot_invio);
			this.files.screenshot_invio.changed = false;
			this.isLoadingScreenshotInvio = false;
		},
		getBase64ScreenshotInvio() {
			this.isLoadingBase64ScreenshotInvio = true;
			return axios.post('/api/storage/get-base-64-file', { path: this.pratica.path_screenshot_invio})
				.then(response => {
					this.base64ScreenshotRegistrazione = response.data;
				})
				.finally(() => {
					this.isLoadingBase64ScreenshotInvio = false;
				})
		},
		download(path, key) {
			const fileName = this.getFileNameFromPath(path);
			if (key == 'screenshot_invio') this.downloadingScreenshotInvio = true;
			axios.post('/api/storage/download',
				{
					path: path
				},
				{
					responseType: 'blob'
				})
				.then(response => {
					saveAs(response.data, fileName);
				})
				.finally(() => {
					if (key == 'screenshot_invio') this.downloadingScreenshotInvio = false;
				})
		},
		setChanged(file) {
			if (file !== null && !this.isLoading) file.changed = true;
			// console.log(this.files)
		},
	}
	
}
</script>

<style scoped>

</style>